'use strict'

{
  // Smooth scroll for hero buttons
  document.addEventListener('DOMContentLoaded', function () {
    var btns = document.querySelectorAll('.hero__btn')
    btns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var href = btn.getAttribute('href')
        if (href && href.charAt(0) === '#') {
          var target = document.querySelector(href)
          if (target) {
            e.preventDefault()
            target.scrollIntoView({ behavior: 'smooth' })
          }
        }
      })
    })
  })
}
